import { FormControlBase } from './form-control-base';

export class CheckboxControl extends FormControlBase<boolean> {
    public controlType: string = 'checkbox';
    public value: boolean = false;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/checkbox-control.ts